<template>
  <div class="max-w-[1800px] 2xl:px-[8em] xl:px-[4em] sm:px-[2em] pt-[60px] justify-self-center w-full">
    <div class="flex mb-[3.5rem] sm:mb-8 justify-between">
      <div class="flex">
        <v-avatar
          size="100"
          class="mr-3 sm:mr-6 ml-3 sm:min-w-[195px] sm:min-h-[195px]"
          :image="'https://api.baranimes.com/images/minia/' + user.minia"
          :style="`background: url(https://api.baranimes.com/images/global/bg_avatar.png) 0% 0% / cover, ${user.fond}`"
        ></v-avatar>
        <div class="flex flex-col justify-evenly">
          <div>
            <h1 class="text-2xl sm:text-4xl font-bold">{{ user.username }}</h1>
            <p>{{ $t("my_list.level") }} {{ user.lvl }}</p>
          </div>
          <p class="text-sm sm:text-xl font-medium">
            {{ $t("my_list.member_since") }} {{ formaterDate(user.since) }} ({{ daysElapsedSince(user.since) }}
            {{ $t("my_list.days") }})
          </p>
        </div>
      </div>
      <div class="flex flex-col justify-between">
        <svg
          v-if="props.url == 'profile'"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          class="mt-1 mr-3 self-end cursor-pointer"
          @click="$emit('change-url', 'settings', 2)"
        >
          <!-- Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
          <path
            fill="currentColor"
            d="m10.135 21l-.362-2.892q-.479-.145-1.035-.454q-.557-.31-.947-.664l-2.668 1.135l-1.865-3.25l2.306-1.739q-.045-.27-.073-.558q-.03-.288-.03-.559q0-.252.03-.53q.028-.278.073-.626L3.258 9.126l1.865-3.212L7.771 7.03q.448-.373.97-.673q.52-.3 1.013-.464L10.134 3h3.732l.361 2.912q.575.202 1.016.463t.909.654l2.725-1.115l1.865 3.211l-2.382 1.796q.082.31.092.569t.01.51q0 .233-.02.491q-.019.259-.088.626l2.344 1.758l-1.865 3.25l-2.681-1.154q-.467.393-.94.673t-.985.445L13.866 21zm1.838-6.5q1.046 0 1.773-.727T14.473 12t-.727-1.773t-1.773-.727q-1.052 0-1.776.727T9.473 12t.724 1.773t1.776.727"
          />
        </svg>
        <button
          v-else-if="friendRef == 1"
          class="bg-linear rounded-xl lg:mt-4 mr-3 flex justify-center items-center font-semibold px-4"
          @click="
            friend();
            friendRef = 2;
          "
        >
          <span class="hidden lg:block">Ajouter en ami</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" class="p-1">
            <!-- Icon from WeUI Icon by WeUI - undefined -->
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M18.75 10.75V8h1.5v2.75H23v1.5h-2.75V15h-1.5v-2.75H16v-1.5zm-10.918 1.6C7.096 11.478 6.5 9.85 6.5 8.71V7a4 4 0 0 1 8 0v1.71c0 1.14-.6 2.773-1.332 3.642l-.361.428c-.59.699-.406 1.588.419 1.99l5.66 2.762c.615.3 1.114 1.093 1.114 1.783v.687a1 1 0 0 1-1.001.998H2a1 1 0 0 1-1-.998v-.687c0-.685.498-1.483 1.114-1.784l5.66-2.762c.821-.4 1.012-1.288.42-1.99z"
            />
          </svg>
        </button>
        <button
          v-else-if="friendRef == 2"
          class="bg-linear rounded-xl lg:mt-4 mr-3 flex justify-center items-center font-semibold px-4"
        >
          <span class="hidden lg:block">Demande envoyée</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 56 56" class="p-1">
            <!-- Icon from Framework7 Icons by Vladimir Kharlampidi - https://github.com/framework7io/framework7-icons/blob/master/LICENSE -->
            <path
              fill="currentColor"
              d="M16.516 49.574h22.757c2.391 0 3.82-1.312 3.82-3.843v-.61c.024-6.469-6.866-11.719-9.89-14.578c-.844-.797-1.289-1.523-1.289-2.578s.445-1.758 1.29-2.578c3-2.907 9.89-7.828 9.89-14.555v-.562c0-2.532-1.43-3.844-3.82-3.844H16.515c-2.344 0-3.633 1.312-3.633 3.633v.773c0 6.727 6.89 11.648 9.914 14.555c.844.82 1.289 1.523 1.289 2.578s-.445 1.781-1.29 2.578c-3.023 2.86-9.913 8.11-9.913 14.578v.82c0 2.32 1.289 3.633 3.633 3.633m.867-36.14h21.234c.89 0 1.031.703.516 1.664c-2.11 3.797-9.211 9.89-11.133 9.89s-9.023-6.047-11.133-9.89c-.515-.961-.375-1.664.516-1.664"
            />
          </svg>
        </button>
        <button
          v-else-if="friendRef == 3"
          class="bg-linear rounded-xl lg:mt-4 mr-3 flex justify-center items-center font-semibold px-4"
          @click="
            friend();
            friendRef = 4;
          "
        >
          <span class="hidden lg:block">Accepter la demande</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" class="p-1">
            <!-- Icon from WeUI Icon by WeUI - undefined -->
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M18.75 10.75V8h1.5v2.75H23v1.5h-2.75V15h-1.5v-2.75H16v-1.5zm-10.918 1.6C7.096 11.478 6.5 9.85 6.5 8.71V7a4 4 0 0 1 8 0v1.71c0 1.14-.6 2.773-1.332 3.642l-.361.428c-.59.699-.406 1.588.419 1.99l5.66 2.762c.615.3 1.114 1.093 1.114 1.783v.687a1 1 0 0 1-1.001.998H2a1 1 0 0 1-1-.998v-.687c0-.685.498-1.483 1.114-1.784l5.66-2.762c.821-.4 1.012-1.288.42-1.99z"
            />
          </svg>
        </button>
        <button
          v-else-if="friendRef == 4"
          class="bg-linear rounded-xl lg:mt-4 mr-3 flex justify-center items-center font-semibold px-4"
        >
          <span class="hidden lg:block">Ami(e)</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" class="p-1">
            <!-- Icon from Flowbite Icons by Themesberg - https://github.com/themesberg/flowbite-icons/blob/main/LICENSE -->
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M8 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4zm7.25-2.095c.478-.86.75-1.85.75-2.905a6 6 0 0 0-.75-2.906a4 4 0 1 1 0 5.811M15.466 20c.34-.588.535-1.271.535-2v-1a5.98 5.98 0 0 0-1.528-4H18a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <v-tabs v-model="tab" class="hidden sm:flex rounded-md" v-if="anime.length || props.url == 'profile'">
          <v-tab :value="1">Profile</v-tab>
          <v-tab :value="2">List</v-tab>
        </v-tabs>
      </div>
    </div>

    <v-window v-model="tab" class="hidden sm:block">
      <v-window-item :value="1" :key="1">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          <!-- Carte 1 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Songs Played</h2>
            <p>1 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 03 js 08 Hrs.</p>
            <img src="https://via.placeholder.com/100x150" alt="Comédie" class="rounded-md mx-auto" />
          </div>

          <!-- Carte 2 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Guess Rate</h2>
            <p>1 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 03 js 08 Hrs.</p>
            <img src="https://via.placeholder.com/100x150" alt="Sci-Fi" class="rounded-md mx-auto" />
          </div>

          <!-- Carte 3 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Etage ascension</h2>
            <p>1 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 15 js 16 Hrs.</p>
            <img src="https://via.placeholder.com/100x150" alt="Fantastique" class="rounded-md mx-auto" />
          </div>

          <!-- Carte 4 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Son le plus trouvé</h2>
            <p>2 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 02 Hrs. 24 Mins.</p>
            <div class="flex gap-2 justify-center">
              <img src="https://via.placeholder.com/70x100" alt="Anime 1" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 2" class="rounded-md" />
            </div>
          </div>

          <!-- Carte 5 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Son le moins trouvé</h2>
            <p>2 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 15 js 18 Hrs.</p>
            <div class="flex gap-2 justify-center">
              <img src="https://via.placeholder.com/70x100" alt="Anime 1" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 2" class="rounded-md" />
            </div>
          </div>

          <!-- Carte 6 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Rank</h2>
            <p>4 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 19 js 03 Hrs.</p>
            <div class="flex gap-2 justify-center">
              <img src="https://via.placeholder.com/70x100" alt="Anime 1" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 2" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 3" class="rounded-md" />
            </div>
          </div>
          <!-- Carte 7 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Duel</h2>
            <p>4 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 19 js 03 Hrs.</p>
            <div class="flex gap-2 justify-center">
              <img src="https://via.placeholder.com/70x100" alt="Anime 1" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 2" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 3" class="rounded-md" />
            </div>
          </div>
          <!-- Carte 8 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Temps moyen reponse</h2>
            <p>4 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 19 js 03 Hrs.</p>
            <div class="flex gap-2 justify-center">
              <img src="https://via.placeholder.com/70x100" alt="Anime 1" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 2" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 3" class="rounded-md" />
            </div>
          </div>
          <!-- Carte 9 -->
          <div class="bg-gray-800 rounded-xl p-4 shadow-md">
            <h2 class="text-xl font-bold mb-2">Emote la plus use</h2>
            <p>4 Anime</p>
            <p>Moyenne : N/A</p>
            <p class="mb-4">Durée totale : 19 js 03 Hrs.</p>
            <div class="flex gap-2 justify-center">
              <img src="https://via.placeholder.com/70x100" alt="Anime 1" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 2" class="rounded-md" />
              <img src="https://via.placeholder.com/70x100" alt="Anime 3" class="rounded-md" />
            </div>
          </div>
        </div>
      </v-window-item>
      <v-window-item :value="2" :key="2">
        <div class="submenu sm:flex">
          <span @click="submenu(0)" class="slider_list_menu0"
            ><span>{{ $t("my_list.watching") }} • {{ anime[0]?.length }}</span></span
          >
          <span @click="submenu(1)"
            ><span>{{ $t("my_list.to_watch") }} • {{ anime[1]?.length }}</span></span
          >
          <span @click="submenu(2)"
            ><span>{{ $t("my_list.completed") }} • {{ anime[2]?.length }}</span></span
          >
          <span @click="submenu(3)"
            ><span>{{ $t("my_list.on_hold") }} • {{ anime[3]?.length }}</span></span
          >
          <span @click="submenu(4)"
            ><span>{{ $t("my_list.dropped") }} • {{ anime[4]?.length }}</span></span
          >
        </div>
        <div class="hidden sm:flex px-4 mb-10">
          <div
            v-for="(item, index) in anime"
            :key="item.id"
            class="justify-center flex slider_list w-full"
            :class="{active: index === 0}"
          >
            <div class="flex justify-between" id="header-submenu">
              <h2 v-if="index === 0" class="slide_title text-[#2ecc71]">{{ $t("my_list.watching") }}</h2>
              <h2 v-if="index === 1" class="slide_title text-[#5d9cec]">{{ $t("my_list.to_watch") }}</h2>
              <h2 v-if="index === 2" class="slide_title text-[#ac92ec]">{{ $t("my_list.completed") }}</h2>
              <h2 v-if="index === 3" class="slide_title text-[#fcc200]">{{ $t("my_list.on_hold") }}</h2>
              <h2 v-if="index === 4" class="slide_title text-[#d8334a]">{{ $t("my_list.dropped") }}</h2>
              <h2 v-if="index === 5" class="slide_title text-[#d8334a]">Tous</h2>
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                density="comfortable"
                label="Rechercher"
                single-line
                flat
                variant="solo"
                :loading="loading"
                clearable
                hide-details
                bg-color="#c7cef8"
                @input="resetItem"
                @click:clear="
                  search = '';
                  resetItem();
                "
                rounded="2xl"
                class="max-w-[400px] border-none outline-none text-black overflow-hidden align-baseline"
              ></v-text-field>
            </div>

            <div class="flex flex-wrap">
              <v-sheet
                v-for="(card, index2) in visibleAnime[index]"
                :key="card.id"
                :height="size"
                :class="{'bg-warning': card?.red}"
                class="flex align-center justify-start overflow-hidden bg-transparent w-full lg:w-1/2 pr-4 mb-3 rounded-2xl duration-300"
              >
                <v-img
                  @click="$emit('change-url', card.url)"
                  :src="'https://api.baranimes.com/images/thumbnail/' + card.poster"
                  loading="lazy"
                  width="100"
                  height="150"
                  class="rounded-2xl max-w-[100px] mr-4"
                >
                </v-img>
                <div class="w-full h-full py-3 pr-5">
                  <div class="flex justify-between mb-1">
                    <div class="pr-2">
                      <h1
                        @click="$emit('change-url', card.url)"
                        class="text-white font-medium text-xl line-clamp-3 leading-[1.4]"
                      >
                        {{ card.title }}
                      </h1>
                    </div>
                    <v-dialog max-width="402">
                      <template v-slot:activator="{props: activatorProps}">
                        <button
                          v-if="props.url == 'profile'"
                          class="hover:scale-105 bg-linear menu-anime"
                          v-bind="activatorProps"
                          @click="
                            menuAnimeToggleModal(
                              card?.status,
                              card?.favorite,
                              card?.score,
                              card?.title,
                              card?.id,
                              index2 + (page - 1) * 10,
                              index
                            ),
                              zindexOverlay()
                          "
                        >
                          <span class="line1"></span>
                          <span class="line2"></span>
                        </button>
                      </template>
                      <template v-slot:default>
                        <div class="w-full h-full flex items-center justify-center shadow-2xl rounded-3xl">
                          <div
                            @click.stop
                            class="rounded-2xl cursor-auto overflow-hidden modal-menu-anime"
                            style="
                              background: linear-gradient(
                                45deg,
                                rgb(47, 221, 222) 0%,
                                rgb(79, 83, 175) 30%,
                                rgb(52, 70, 115) 65%,
                                rgb(34, 50, 85) 100%
                              );
                            "
                          >
                            <h3 class="bg-linear text-lg line-clamp-1 font-medium max-w-[402px] text-center p-1">
                              {{ animeUser?.title }}
                            </h3>
                            <div class="flex justify-center flex-wrap p-4 pt-5">
                              <div class="flex flex-col items-center w-[74px] mb-3">
                                <button
                                  class="rounded-full bg-[#2ecc71] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                  :class="{active: animeUser?.status === 1}"
                                  @click="menuAnime(1)"
                                >
                                  <svg
                                    class="hover:text-[#2ecc71] duration-300 w-full h-full p-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M8 17.175V6.825q0-.425.3-.713t.7-.287q.125 0 .263.037t.262.113l8.15 5.175q.225.15.338.375t.112.475q0 .25-.112.475t-.338.375l-8.15 5.175q-.125.075-.262.113T9 18.175q-.4 0-.7-.288t-.3-.712"
                                    />
                                  </svg></button
                                ><span class="font-medium text-sm">{{ $t("my_list.watching") }}</span>
                              </div>
                              <div class="flex flex-col items-center w-[74px] mb-3">
                                <button
                                  class="rounded-full bg-[#5d9cec] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                  :class="{active: animeUser?.status === 2}"
                                  @click="menuAnime(2)"
                                >
                                  <svg
                                    class="hover:text-[#5d9cec] duration-300 w-full h-full p-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M13 11.6V8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8v3.975q0 .2.075.388t.225.337l3.3 3.3q.275.275.7.275T16 16q.275-.275.275-.7T16 14.6zM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.325 0 5.663-2.337T20 12q0-3.325-2.337-5.663T12 4Q8.675 4 6.337 6.338T4 12q0 3.325 2.338 5.663T12 20"
                                    />
                                  </svg></button
                                ><span class="font-medium text-sm">{{ $t("my_list.to_watch") }}</span>
                              </div>
                              <div class="flex flex-col items-center w-[74px] mb-3">
                                <button
                                  class="rounded-full bg-[#ac92ec] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                  :class="{active: animeUser?.status === 3}"
                                  @click="menuAnime(3)"
                                >
                                  <svg
                                    class="hover:text-[#ac92ec] duration-300 w-full h-full p-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M7 14v6q0 .425-.288.713T6 21q-.425 0-.712-.288T5 20V5q0-.425.288-.712T6 4h7.175q.35 0 .625.225t.35.575L14.4 6H19q.425 0 .713.288T20 7v8q0 .425-.288.713T19 16h-5.175q-.35 0-.625-.225t-.35-.575L12.6 14z"
                                    />
                                  </svg></button
                                ><span class="font-medium text-sm">{{ $t("my_list.completed") }}</span>
                              </div>
                              <div class="flex flex-col items-center w-[74px] mb-3">
                                <button
                                  class="rounded-full bg-[#fcc200] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                  :class="{active: animeUser?.status === 4}"
                                  @click="menuAnime(4)"
                                >
                                  <svg
                                    class="hover:text-[#fcc200] duration-300 w-full h-full p-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M16 19q-.825 0-1.412-.587T14 17V7q0-.825.588-1.412T16 5q.825 0 1.413.588T18 7v10q0 .825-.587 1.413T16 19m-8 0q-.825 0-1.412-.587T6 17V7q0-.825.588-1.412T8 5q.825 0 1.413.588T10 7v10q0 .825-.587 1.413T8 19"
                                    />
                                  </svg></button
                                ><span class="font-medium text-sm">{{ $t("my_list.on_hold") }}</span>
                              </div>
                              <div class="flex flex-col items-center w-[74px] mb-3">
                                <button
                                  class="rounded-full bg-[#d8334a] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                  :class="{active: animeUser?.status === 5}"
                                  @click="menuAnime(5)"
                                >
                                  <svg
                                    class="hover:text-[#d8334a] duration-300 w-full h-full p-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M7 15.385v-6.77q0-.666.475-1.14Q7.949 7 8.615 7h6.77q.666 0 1.14.475q.475.474.475 1.14v6.77q0 .666-.475 1.14q-.474.475-1.14.475h-6.77q-.666 0-1.14-.475Q7 16.051 7 15.385"
                                    />
                                  </svg></button
                                ><span class="font-medium text-sm">{{ $t("my_list.dropped") }}</span>
                              </div>
                            </div>
                            <div class="flex justify-evenly flex-wrap p-4 pt-0">
                              <div class="flex flex-col items-center mb-4">
                                <div class="flex">
                                  <svg
                                    class="cursor-pointer mt-[6px]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    @click="rating = 0"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="m12 13.4l2.9 2.9q.275.275.7.275t.7-.275q.275-.275.275-.7t-.275-.7L13.4 12l2.9-2.9q.275-.275.275-.7t-.275-.7q-.275-.275-.7-.275t-.7.275L12 10.6L9.1 7.7q-.275-.275-.7-.275t-.7.275q-.275.275-.275.7t.275.7l2.9 2.9l-2.9 2.9q-.275.275-.275.7t.275.7q.275.275.7.275t.7-.275zm0 8.6q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22"
                                    />
                                  </svg>
                                  <v-rating
                                    hover
                                    half-increments
                                    v-model="rating"
                                    :length="5"
                                    :size="24"
                                    :model-value="animeUser?.score / 2"
                                    color="#ffffff"
                                    active-color="#FFB600"
                                    class="m-0 h-[26px]"
                                  />
                                </div>
                                <span class="font-medium text-sm mt-1">{{ $t("my_list.rating") }}</span>
                              </div>
                              <div class="flex flex-col items-center w-[74px]">
                                <button
                                  class="rounded-full bg-[#ff7d7d] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                  :class="{active: animeUser?.favorite === 1}"
                                  @click="menuFavAnime"
                                >
                                  <svg
                                    class="hover:text-[#ff7d7d] duration-300 w-full h-full p-2 mt-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M12 20.325q-.35 0-.712-.125t-.638-.4l-1.725-1.575q-2.65-2.425-4.788-4.812T2 8.15Q2 5.8 3.575 4.225T7.5 2.65q1.325 0 2.5.562t2 1.538q.825-.975 2-1.537t2.5-.563q2.35 0 3.925 1.575T22 8.15q0 2.875-2.125 5.275T15.05 18.25l-1.7 1.55q-.275.275-.637.4t-.713.125"
                                    />
                                  </svg></button
                                ><span class="font-medium text-sm">{{ $t("my_list.favorite") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </v-dialog>
                  </div>
                  <div class="flex justify-between">
                    <div class="flex">
                      <div class="flex">
                        <span class="font-medium text-gray-200">{{ $t("my_list.episode") }}: </span>
                        <span class="text-white ml-1">{{ card.nbEp }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-sheet>
            </div>
            <v-pagination
              v-if="index === 5"
              v-model="page2"
              :length="Math.ceil(searchResult?.length / 10)"
            ></v-pagination>
            <v-pagination v-else v-model="page" :length="Math.ceil(anime[index]?.length / 10)"></v-pagination>
          </div>
        </div>
      </v-window-item>
    </v-window>
    <swiper
      class="mySwiper sm:hidden w-[100vw] overflow-visible"
      style="height: calc(100vh - 236px)"
      :pagination="pagination"
      :modules="modules"
    >
      <swiper-slide>cc</swiper-slide>
      <swiper-slide v-for="(items, index2) in [1, 2, 3, 4, 5]" :key="items.id" class="justify-center flex">
        <v-virtual-scroll :items="anime[index2]" height="calc(100vh - 236px)" :key="anime[index2]" item-height="150">
          <template v-slot:default="{item, index}">
            <div v-if="index === 0" class="ml-2 mt-[70px]">
              <h2 v-if="index2 === 0" class="slide_title text-[#2ecc71]">
                {{ $t("my_list.watching") }} • {{ anime[0]?.length }}
              </h2>
              <h2 v-if="index2 === 1" class="slide_title text-[#5d9cec]">
                {{ $t("my_list.to_watch") }} • {{ anime[1]?.length }}
              </h2>
              <h2 v-if="index2 === 2" class="slide_title text-[#ac92ec]">
                {{ $t("my_list.completed") }} • {{ anime[2]?.length }}
              </h2>
              <h2 v-if="index2 === 3" class="slide_title text-[#fcc200]">
                {{ $t("my_list.on_hold") }} • {{ anime[3]?.length }}
              </h2>
              <h2 v-if="index2 === 4" class="slide_title text-[#d8334a]">
                {{ $t("my_list.dropped") }} • {{ anime[4]?.length }}
              </h2>
            </div>
            <v-sheet
              :height="size"
              :class="{'bg-warning': item?.red}"
              class="flex align-center justify-start overflow-hidden bg-transparent w-full px-2 mb-3 rounded-2xl duration-300"
            >
              <v-img
                @click="$emit('change-url', item.url)"
                :src="'https://api.baranimes.com/images/thumbnail/' + item?.poster"
                loading="lazy"
                width="100"
                height="150"
                class="rounded-2xl max-w-[100px] mr-4"
              >
              </v-img>
              <div class="w-full h-full py-3 pr-5">
                <div class="flex justify-between mb-1">
                  <div class="pr-2">
                    <h1
                      @click="$emit('change-url', item.url)"
                      class="text-white font-medium text-xl line-clamp-3 leading-[1.4]"
                    >
                      {{ item?.title }}
                    </h1>
                  </div>
                  <v-dialog max-width="402">
                    <template v-slot:activator="{props: activatorProps}">
                      <button
                        v-if="props.url == 'profile'"
                        class="hover:scale-105 bg-linear menu-anime"
                        v-bind="activatorProps"
                        @click="
                          menuAnimeToggleModal(
                            item?.status,
                            item?.favorite,
                            item?.score,
                            item?.title,
                            item?.id,
                            index2 + (page - 1) * 10,
                            index
                          ),
                            zindexOverlay()
                        "
                      >
                        <span class="line1"></span>
                        <span class="line2"></span>
                      </button>
                    </template>
                    <template v-slot:default>
                      <div class="w-full h-full flex items-center justify-center shadow-2xl rounded-3xl">
                        <div
                          @click.stop
                          class="rounded-2xl cursor-auto overflow-hidden modal-menu-anime"
                          style="
                            background: linear-gradient(
                              45deg,
                              rgb(47, 221, 222) 0%,
                              rgb(79, 83, 175) 30%,
                              rgb(52, 70, 115) 65%,
                              rgb(34, 50, 85) 100%
                            );
                          "
                        >
                          <h3 class="bg-linear text-lg line-clamp-1 font-medium max-w-[402px] text-center p-1">
                            {{ animeUser?.title }}
                          </h3>
                          <div class="flex justify-center flex-wrap p-4 pt-5">
                            <div class="flex flex-col items-center w-[74px] mb-3">
                              <button
                                class="rounded-full bg-[#2ecc71] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                :class="{active: animeUser?.status === 1}"
                                @click="menuAnime(1)"
                              >
                                <svg
                                  class="hover:text-[#2ecc71] duration-300 w-full h-full p-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M8 17.175V6.825q0-.425.3-.713t.7-.287q.125 0 .263.037t.262.113l8.15 5.175q.225.15.338.375t.112.475q0 .25-.112.475t-.338.375l-8.15 5.175q-.125.075-.262.113T9 18.175q-.4 0-.7-.288t-.3-.712"
                                  />
                                </svg></button
                              ><span class="font-medium text-sm">{{ $t("my_list.watching") }}</span>
                            </div>
                            <div class="flex flex-col items-center w-[74px] mb-3">
                              <button
                                class="rounded-full bg-[#5d9cec] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                :class="{active: animeUser?.status === 2}"
                                @click="menuAnime(2)"
                              >
                                <svg
                                  class="hover:text-[#5d9cec] duration-300 w-full h-full p-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M13 11.6V8q0-.425-.288-.712T12 7q-.425 0-.712.288T11 8v3.975q0 .2.075.388t.225.337l3.3 3.3q.275.275.7.275T16 16q.275-.275.275-.7T16 14.6zM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.325 0 5.663-2.337T20 12q0-3.325-2.337-5.663T12 4Q8.675 4 6.337 6.338T4 12q0 3.325 2.338 5.663T12 20"
                                  />
                                </svg></button
                              ><span class="font-medium text-sm">{{ $t("my_list.to_watch") }}</span>
                            </div>
                            <div class="flex flex-col items-center w-[74px] mb-3">
                              <button
                                class="rounded-full bg-[#ac92ec] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                :class="{active: animeUser?.status === 3}"
                                @click="menuAnime(3)"
                              >
                                <svg
                                  class="hover:text-[#ac92ec] duration-300 w-full h-full p-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M7 14v6q0 .425-.288.713T6 21q-.425 0-.712-.288T5 20V5q0-.425.288-.712T6 4h7.175q.35 0 .625.225t.35.575L14.4 6H19q.425 0 .713.288T20 7v8q0 .425-.288.713T19 16h-5.175q-.35 0-.625-.225t-.35-.575L12.6 14z"
                                  />
                                </svg></button
                              ><span class="font-medium text-sm">{{ $t("my_list.completed") }}</span>
                            </div>
                            <div class="flex flex-col items-center w-[74px] mb-3">
                              <button
                                class="rounded-full bg-[#fcc200] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                :class="{active: animeUser?.status === 4}"
                                @click="menuAnime(4)"
                              >
                                <svg
                                  class="hover:text-[#fcc200] duration-300 w-full h-full p-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M16 19q-.825 0-1.412-.587T14 17V7q0-.825.588-1.412T16 5q.825 0 1.413.588T18 7v10q0 .825-.587 1.413T16 19m-8 0q-.825 0-1.412-.587T6 17V7q0-.825.588-1.412T8 5q.825 0 1.413.588T10 7v10q0 .825-.587 1.413T8 19"
                                  />
                                </svg></button
                              ><span class="font-medium text-sm">{{ $t("my_list.on_hold") }}</span>
                            </div>
                            <div class="flex flex-col items-center w-[74px] mb-3">
                              <button
                                class="rounded-full bg-[#d8334a] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                :class="{active: animeUser?.status === 5}"
                                @click="menuAnime(5)"
                              >
                                <svg
                                  class="hover:text-[#d8334a] duration-300 w-full h-full p-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M7 15.385v-6.77q0-.666.475-1.14Q7.949 7 8.615 7h6.77q.666 0 1.14.475q.475.474.475 1.14v6.77q0 .666-.475 1.14q-.474.475-1.14.475h-6.77q-.666 0-1.14-.475Q7 16.051 7 15.385"
                                  />
                                </svg></button
                              ><span class="font-medium text-sm">{{ $t("my_list.dropped") }}</span>
                            </div>
                          </div>
                          <div class="flex justify-evenly flex-wrap p-4 pt-0">
                            <div class="flex flex-col items-center mb-4">
                              <div class="flex">
                                <svg
                                  class="cursor-pointer mt-[6px]"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  @click="rating = 0"
                                >
                                  <path
                                    fill="currentColor"
                                    d="m12 13.4l2.9 2.9q.275.275.7.275t.7-.275q.275-.275.275-.7t-.275-.7L13.4 12l2.9-2.9q.275-.275.275-.7t-.275-.7q-.275-.275-.7-.275t-.7.275L12 10.6L9.1 7.7q-.275-.275-.7-.275t-.7.275q-.275.275-.275.7t.275.7l2.9 2.9l-2.9 2.9q-.275.275-.275.7t.275.7q.275.275.7.275t.7-.275zm0 8.6q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22"
                                  />
                                </svg>
                                <v-rating
                                  hover
                                  half-increments
                                  v-model="rating"
                                  :length="5"
                                  :size="24"
                                  :model-value="animeUser?.score / 2"
                                  color="#ffffff"
                                  active-color="#FFB600"
                                  class="m-0 h-[26px]"
                                />
                              </div>
                              <span class="font-medium text-sm mt-1">{{ $t("my_list.rating") }}</span>
                            </div>
                            <div class="flex flex-col items-center w-[74px]">
                              <button
                                class="rounded-full bg-[#ff7d7d] duration-300 hover:bg-white w-[50px] h-[50px] flex justify-center items-center"
                                :class="{active: animeUser?.favorite === 1}"
                                @click="menuFavAnime"
                              >
                                <svg
                                  class="hover:text-[#ff7d7d] duration-300 w-full h-full p-2 mt-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M12 20.325q-.35 0-.712-.125t-.638-.4l-1.725-1.575q-2.65-2.425-4.788-4.812T2 8.15Q2 5.8 3.575 4.225T7.5 2.65q1.325 0 2.5.562t2 1.538q.825-.975 2-1.537t2.5-.563q2.35 0 3.925 1.575T22 8.15q0 2.875-2.125 5.275T15.05 18.25l-1.7 1.55q-.275.275-.637.4t-.713.125"
                                  />
                                </svg></button
                              ><span class="font-medium text-sm">{{ $t("my_list.favorite") }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-dialog>
                </div>
                <div class="flex justify-between">
                  <div class="flex">
                    <div class="flex">
                      <span class="font-medium text-gray-200">{{ $t("my_list.episode") }}: </span>
                      <span class="text-white ml-1">{{ item?.nbEp }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-sheet>
          </template>
        </v-virtual-scroll>
      </swiper-slide>
    </swiper>
    <v-snackbar v-model="snackbar" timeout="3000" class="text-center" color="#008ca8">
      <p class="font-medium text-center">{{ $t("my_list.status_updated") }}</p>
    </v-snackbar>
  </div>
</template>
<script setup>
  import {ref, onMounted, watch, computed, onBeforeUnmount} from "vue";
  import {Swiper, SwiperSlide} from "swiper/vue";
  import {Pagination} from "swiper/modules";
  import {useAuthStore} from "@/stores/auth";
  import "swiper/css";
  import "swiper/css/pagination";
  import {useRouter} from "vue-router";
  import {useI18n} from "vue-i18n";
  import {useSeoMeta} from "@unhead/vue";
  import {useGlobalStore} from "@/stores/global";
  import {useFetch, useWebWorkerFn} from "@vueuse/core";
  import {useJoinRoomStore} from "@/stores/joinRoom";

  const joinRoom = useJoinRoomStore();
  const socket = joinRoom.socket;
  const props = defineProps({
    url: String,
  });
  const {workerFn, workerTerminate} = useWebWorkerFn(searchbar, {
    timeout: 30000,
  });
  const user = ref({});
  const global = useGlobalStore();
  const {t} = useI18n();
  const router = useRouter();
  const auth = useAuthStore();
  const tab = ref(2);
  const anime = ref([]);
  const friendRef = ref(0);
  const modules = [Pagination];
  const page = ref(1);
  const page2 = ref(1);
  const itemsToShow = ref(10);
  const visibleAnime = ref([]);
  const activeSubMenu = ref(0);
  const animeUser = ref({});
  const snackbar = ref(null);
  const search = ref("");
  const loading = ref(false);
  const searchResult = ref([]);
  let timeoutId;
  const rating = ref(null);
  const renderBtn = ref([
    {
      title: computed(() => t("my_list.watching")),
    },
    {
      title: computed(() => t("my_list.watching")),
    },
    {
      title: computed(() => t("my_list.to_watch")),
    },
    {
      title: computed(() => t("my_list.completed")),
    },
    {
      title: computed(() => t("my_list.on_hold")),
    },
    {
      title: computed(() => t("my_list.dropped")),
    },
  ]);
  useSeoMeta({
    title: computed(() => t("header.menu.lists") + " - Baranimes"),
    ogTitle: computed(() => t("header.menu.lists") + " - Baranimes"),
    description: computed(() => t("home.description")),
    ogDescription: computed(() => t("home.description")),
    ogImage: "https://api.baranimes.com/images/global/favicon.png",
    ogType: "website",
    ogUrl: window.location.href,
    ogSiteName: "baranimes.com",
    twitterCard: "summary_large_image",
    twitterTitle: computed(() => t("header.menu.lists") + " - Baranimes"),
    twitterSite: "@baranimes",
    twitterDescription: computed(() => t("home.description")),
    twitterImage: "https://api.baranimes.com/images/global/favicon.png",
  });
  watch(page, pageIndex => {
    const start = (pageIndex - 1) * itemsToShow.value;
    const end = pageIndex * itemsToShow.value;
    visibleAnime.value[activeSubMenu.value] = [];
    for (let i = start; i < end && i < anime.value[activeSubMenu.value].length; i++) {
      visibleAnime.value[activeSubMenu.value].push(anime.value[activeSubMenu.value][i]);
    }
  });
  watch(page2, pageIndex => {
    const start = (pageIndex - 1) * itemsToShow.value;
    const end = pageIndex * itemsToShow.value;
    visibleAnime.value[5] = [];
    for (let i = start; i < end && i < anime.value[5].length; i++) {
      if (searchResult.value[i]) {
        visibleAnime.value[5].push(searchResult.value[i]);
      }
    }
  });
  watch(rating, async value => {
    animeUser.value.score = value * 2;
    await useFetch("https://api.baranimes.com/api/anime/user/update/rating", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        idAnime: animeUser.value.id,
        value: value * 2,
      }),
    });
    anime.value[animeUser.value.status - 1][animeUser.value.index].score = value * 2;
    snackbar.value = true;
  });
  const pagination = ref({
    clickable: true,
    renderBullet: function (index, className) {
      return `<span class=" ${className}"><span class="nowrap flex place-content-center">${renderBtn.value[index].title}</span></span>`;
    },
  });
  onMounted(async () => {
    if (props.url == "profile") {
      user.value.username = auth.user.username;
      user.value.lvl = auth.user.lvl;
      user.value.since = auth.user.since;
      user.value.minia = auth.user.minia;
      user.value.fond = auth.user.fond;
      const {data: response} = await useFetch("https://api.baranimes.com/api/user/profile", {
        method: "post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": auth.user.crsf,
        },
      });
      setTimeout(function () {
        anime.value = JSON.parse(response.value);

        anime.value[5] = [].concat(anime.value[0], anime.value[1], anime.value[2], anime.value[3], anime.value[4]);

        global.pageLoad();
        updateSlicedArray();

        setTimeout(function () {
          const scrollElements = document.querySelectorAll(".mySwiper .v-virtual-scroll");

          scrollElements.forEach(el => {
            el.addEventListener("scroll", () => {
              if (el.scrollTop) {
                document.querySelectorAll("[data-vsbs-content")[0].style.height = "101vh";
                document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop = 1;
                document.querySelectorAll("[data-vsbs-scroll]")[0].style.overflow = "hidden";
              } else {
                document.querySelectorAll("[data-vsbs-content")[0].style = "";
                document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop = 0;
                document.querySelectorAll("[data-vsbs-scroll]")[0].style = "";
              }
            });
            let startY = 0;

            el.addEventListener("touchstart", e => {
              startY = e.touches[0].clientY;
            });

            el.addEventListener("touchmove", e => {
              const currentY = e.touches[0].clientY;
              const deltaY = currentY - startY;

              if (el.scrollTop === 0 && deltaY > 0) {
                document.querySelectorAll("[data-vsbs-content")[0].style = "";
                document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop = 0;
                document.querySelectorAll("[data-vsbs-scroll]")[0].style = "";
              }
            });
          });
        }, 1);
      }, 150);
    } else {
      tab.value = 1;
      socket.emit("profile", props.url);
      socket.on("profile", (data, userInfo) => {
        global.pageLoad();
        if (data == "404") {
          router.push({name: "404"});
          return;
        }
        user.value.username = userInfo[0].username;
        user.value.lvl = userInfo[0].lvl;
        user.value.since = userInfo[0].since;
        user.value.minia = userInfo[0].minia;
        user.value.fond = userInfo[0].fond;
        if (userInfo[0].isFriend) {
          friendRef.value = 4;
        } else if (userInfo[0].requestReceived) {
          friendRef.value = 3;
        } else if (userInfo[0].requestSent) {
          friendRef.value = 2;
        } else if (userInfo[0].id == auth.user.idUser) {
          friendRef.value = 0;
        } else {
          friendRef.value = 1;
        }
        if (!data) {
          return;
        }
        setTimeout(function () {
          anime.value = data;

          anime.value[5] = [].concat(anime.value[0], anime.value[1], anime.value[2], anime.value[3], anime.value[4]);

          updateSlicedArray();

          setTimeout(function () {
            const scrollElements = document.querySelectorAll(".mySwiper .v-virtual-scroll");

            scrollElements.forEach(el => {
              el.addEventListener("scroll", () => {
                if (el.scrollTop) {
                  document.querySelectorAll("[data-vsbs-content")[0].style.height = "101vh";
                  document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop = 1;
                  document.querySelectorAll("[data-vsbs-scroll]")[0].style.overflow = "hidden";
                } else {
                  document.querySelectorAll("[data-vsbs-content")[0].style = "";
                  document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop = 0;
                  document.querySelectorAll("[data-vsbs-scroll]")[0].style = "";
                }
              });
              let startY = 0;

              el.addEventListener("touchstart", e => {
                startY = e.touches[0].clientY;
              });

              el.addEventListener("touchmove", e => {
                const currentY = e.touches[0].clientY;
                const deltaY = currentY - startY;

                if (el.scrollTop === 0 && deltaY > 0) {
                  document.querySelectorAll("[data-vsbs-content")[0].style = "";
                  document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop = 0;
                  document.querySelectorAll("[data-vsbs-scroll]")[0].style = "";
                }
              });
            });
          }, 1);
        }, 150);
      });
    }
  });
  onBeforeUnmount(() => {
    const scrollElements = document.querySelectorAll(".mySwiper .v-virtual-scroll");

    scrollElements.forEach(el => {
      el.removeEventListener("scroll", {});
      el.removeEventListener("touchstart", {});
      el.removeEventListener("touchmove", {});
    });
  });
  function friend() {
    socket.emit("friend:request", props.url);
  }
  function zindexOverlay() {
    setTimeout(function () {
      document.querySelector(".v-overlay-container .v-overlay").style.zIndex = 4000;
    }, 1);
  }
  const resetItem = () => {
    if (!search.value) {
      submenu(1);
      return;
    }
    loading.value = true;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(async function () {
      workerTerminate("PENDING");
      searchResult.value = await workerFn(JSON.stringify(anime.value[5]), JSON.stringify(search.value));
      visibleAnime.value[5] = [];
      for (let i = 0; i < 10 && i < anime.value[5].length; i++) {
        if (searchResult.value[i]) {
          visibleAnime.value[5].push(searchResult.value[i]);
        }
      }
      document.querySelectorAll(".submenu>span")[0].removeAttribute("class");
      document.querySelectorAll(".submenu>span")[0].classList.add("slider_list_menu5");

      document.querySelectorAll(".slider_list").forEach((_, i) => {
        document.querySelectorAll(".slider_list")[i].classList.remove("active");
      });
      document.querySelectorAll(".slider_list")[5].classList.add("active");
      activeSubMenu.value = 5;
      page2.value = 1;
      document.querySelectorAll("#header-submenu input")[5].focus();
      loading.value = false;
    }, 500);
  };
  function searchbar(animeInput, input) {
    animeInput = JSON.parse(animeInput);
    input = JSON.parse(input);
    let searchResultTempo = animeInput.filter(item => {
      return item.title
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s]/gi, "")
        .replace(/[-/\\^$*+?.()|[\]{}]/g, "")
        .replace(/\s+/g, "")
        .toLowerCase()
        .trim()
        .includes(
          input
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/gi, "")
            .replace(/[-/\\^$*+?.()|[\]{}]/g, "")
            .replace(/\s+/g, "")
            .toLowerCase()
            .trim()
        );
    });

    return searchResultTempo;
  }
  function formaterDate(dateStr) {
    if (!dateStr) {
      return "Inconnu";
    }
    let date = new Date(dateStr);
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let options = {timeZone: timeZone, year: "numeric", month: "long", day: "numeric"};
    return new Intl.DateTimeFormat(undefined, options).format(date);
  }
  function daysElapsedSince(date) {
    const dateInMilliseconds = new Date(date).getTime();
    const currentDateInMilliseconds = new Date().getTime();
    const differenceInMilliseconds = currentDateInMilliseconds - dateInMilliseconds;
    const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

    return differenceInDays;
  }
  function submenu(submenu) {
    document.querySelectorAll(".submenu>span")[0].removeAttribute("class");
    document.querySelectorAll(".submenu>span")[0].classList.add("slider_list_menu" + submenu);

    document.querySelectorAll(".slider_list").forEach((_, i) => {
      document.querySelectorAll(".slider_list")[i].classList.remove("active");
    });
    document.querySelectorAll(".slider_list")[submenu].classList.add("active");
    activeSubMenu.value = submenu;
    updateSlicedArray();
  }
  const updateSlicedArray = () => {
    for (let idx = 0; idx < 5; idx++) {
      visibleAnime.value[idx] = [];
      for (let i = 0; i < itemsToShow.value && i < anime.value[idx].length; i++) {
        visibleAnime.value[idx].push(anime.value[idx][i]);
      }
    }
    page.value = 1;
  };
  async function menuAnime(value) {
    if (animeUser.value.status === value) {
      anime.value[animeUser.value.indexPrev][animeUser.value.index].red = 1;
      anime.value[animeUser.value.indexPrev][animeUser.value.index].status = 0;

      animeUser.value.status = 0;
    } else {
      anime.value[animeUser.value.indexPrev][animeUser.value.index].red = null;
      animeUser.value.status = value;
    }
    await useFetch("https://api.baranimes.com/api/anime/user/update/menu", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        idAnime: animeUser.value.id,
        value: animeUser.value.status,
      }),
    });
    if (animeUser.value.status) {
      anime.value[animeUser.value.status - 1].push(anime.value[animeUser.value.indexPrev][animeUser.value.index]);
      anime.value[animeUser.value.indexPrev].splice(animeUser.value.index, 1);
      anime.value[animeUser.value.status - 1][anime.value[animeUser.value.status - 1].length - 1].status =
        animeUser.value.status;
      animeUser.value.index = anime.value[animeUser.value.status - 1].length - 1;
      animeUser.value.indexPrev = animeUser.value.status - 1;
    }

    const start = (page.value - 1) * itemsToShow.value;
    const end = page.value * itemsToShow.value;
    visibleAnime.value[activeSubMenu.value] = [];
    for (let i = start; i < end && i < anime.value[activeSubMenu.value].length; i++) {
      visibleAnime.value[activeSubMenu.value].push(anime.value[activeSubMenu.value][i]);
    }

    snackbar.value = true;
  }
  async function menuFavAnime() {
    if (animeUser.value?.favorite === 1) {
      animeUser.value.favorite = 0;
    } else {
      animeUser.value.favorite = 1;
    }
    await useFetch("https://api.baranimes.com/api/anime/user/update/fav", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
      body: JSON.stringify({
        idAnime: animeUser.value.id,
        value: animeUser.value.favorite,
      }),
    });
    anime.value[animeUser.value.status - 1][animeUser.value.index].favorite = animeUser.value.favorite;

    snackbar.value = true;
  }
  const menuAnimeToggleModal = (status, favorite, score, title, id, index, indexPrev) => {
    animeUser.value.id = id;
    animeUser.value.title = title;
    animeUser.value.status = status;
    animeUser.value.favorite = favorite;
    animeUser.value.score = score;
    animeUser.value.index = index;
    animeUser.value.indexPrev = indexPrev;
  };
  onBeforeUnmount(() => {
    socket.off("profile");
  });
</script>
<style scoped>
  .slider_list {
    display: none;
  }
  .active.slider_list {
    display: block;
  }
  .slide_title {
    margin-bottom: 25px;
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 700;
    border-left: 4px solid;
    padding-left: 20px;
  }
  .submenu {
    white-space: nowrap;
    overflow: visible;
    width: 100%;
    text-align: center;
    transition: 0.3s;
    margin-bottom: 35px;
    position: relative;
    margin-top: 5px;
  }
  .submenu > span {
    min-width: calc(20% - 10px);
    border-radius: 100px;
    font-weight: 600;
    height: 33px;
    margin: 0 5px;
    background: rgb(255 255 255 / 10%);
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .submenu > span:first-child::before {
    content: "";
    width: calc(20% - 10px);
    position: absolute;
    opacity: 1;
    border-radius: 100px;
    height: 33px;
    transition: 0.3s;
    pointer-events: none;
  }
  .submenu > span > span {
    position: relative;
  }
  .submenu .slider_list_menu0::before {
    background: #2ecc71;
    left: 5px;
  }

  .submenu .slider_list_menu1::before {
    background: #5d9cec;
    left: calc(20% + 5px);
  }

  .submenu .slider_list_menu2::before {
    background: #ac92ec;
    left: calc(40% + 5px);
  }

  .submenu .slider_list_menu3::before {
    background: #fcc200;
    left: calc(60% + 5px);
  }

  .submenu .slider_list_menu4::before {
    background: #d8334a;
    left: calc(80% + 5px);
  }
  :deep(
      .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
      .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet
    ) {
    min-width: calc(33.333333% - 10px);
    border-radius: 100px;
    font-weight: 600;
    height: 33px;
    margin: 0 5px;
    background: hsla(0, 0%, 100%, 0.1);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    opacity: 1;
    cursor: pointer;
    padding-top: 4px;
    transition: 0.3s;
  }
  :deep(
      .swiper-horizontal > .swiper-pagination-bullets,
      .swiper-pagination-bullets.swiper-pagination-horizontal,
      .swiper-pagination-custom,
      .swiper-pagination-fraction
    ) {
    top: -40px;
    height: 0;
    display: flex;
    justify-content: right;
  }

  :deep(
      .swiper-pagination-bullet:nth-child(4).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
    ) {
    margin-right: calc(-33.33333% + 5px) !important;
  }
  :deep(
      .swiper-pagination-bullet:nth-child(3).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
    ) {
    margin-right: calc(-66.66666% + 5px) !important;
  }
  :deep(
      .swiper-pagination-bullet:nth-child(2).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
    ) {
    margin-right: calc(-100% + 5px) !important;
  }
  :deep(
      .swiper-pagination-bullet:nth-child(1).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
    ) {
    margin-right: calc(-100% + 5px) !important;
  }
  :deep(.swiper-pagination-bullet:nth-child(6)::before) {
    content: "";
    width: calc(33.33333% - 10px);
    position: absolute;
    opacity: 1;
    border-radius: 100px;
    height: 33px;
    transition: 0.3s;
    pointer-events: none;
    top: 0px;
    background: #d8334a;
    left: calc(66.66666% + 5px);
  }
  :deep(.swiper-pagination-bullet > span) {
    position: relative;
    z-index: 1;
  }
  :deep(
      .swiper-pagination-bullet:nth-child(1).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet::before
    ) {
    background: red;
    left: 5px;
  }
  :deep(
      .swiper-pagination-bullet:nth-child(2).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet::before
    ) {
    background: #2ecc71;
    left: calc(33.33333% + 5px);
  }

  :deep(
      .swiper-pagination-bullet:nth-child(3).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet::before
    ) {
    background: #5d9cec;
    left: calc(33.33333% + 5px);
  }

  :deep(
      .swiper-pagination-bullet:nth-child(4).swiper-pagination-bullet-active
        + .swiper-pagination-bullet
        + .swiper-pagination-bullet::before
    ) {
    background: #ac92ec;
    left: calc(33.33333% + 5px);
  }

  :deep(.swiper-pagination-bullet:nth-child(5).swiper-pagination-bullet-active + .swiper-pagination-bullet::before) {
    background: #fcc200;
    left: calc(33.33333% + 5px);
  }
  .bg-warning {
    background: #99444485 !important;
  }
  :deep(.v-virtual-scroll__container) {
    top: -55px;
    position: relative;
  }
</style>
